import React from 'react';
import { ShieldCheck, FileText, ExternalLink } from 'lucide-react';

function Policy() {
  return (
    <div className="min-h-screen bg-parchment pt-16 font-serif">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <ShieldCheck className="h-16 w-16 text-parchment-dark" />
          </div>
          <h1 className="vintage-title">Privacy Policy</h1>
          <p className="vintage-subtitle max-w-3xl mx-auto">
            Learn how we handle your data with care and responsibility.
          </p>
        </div>
        
        <div className="vintage-card mb-12">
  <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
    <FileText className="h-6 w-6" />
    Data Collection
  </h2>
  <p className="text-parchment-dark/80 leading-relaxed mb-4">
    We are committed to respecting your privacy. Most features of our platform can be accessed without any login or personal data collection.
  </p>
  <p className="text-parchment-dark/80 leading-relaxed mb-4">
    Only when using advanced features like <strong>Historical Dialogue</strong> and <strong>Knowledge Quest</strong>, we ask for your email to personalize your experience and enable progress tracking.
  </p>
  <ul className="list-disc list-inside text-parchment-dark/80 mb-6 space-y-2">
    <li>
      <strong>Email:</strong> Used only for account identification in advanced features. We never ask for or store your password.
    </li>
    <li>
      <strong>Search History (Optional):</strong> Stored locally or with your consent to provide personalized search experiences.
    </li>
    <li>
      <strong>Quiz Scores:</strong> Saved during advanced interactions to help tailor your learning journey.
    </li>
  </ul>
  <p className="text-parchment-dark/80 leading-relaxed">
    Your passwords are never accessed by us and are handled securely through your browser or third-party providers if used.
  </p>
</div>


        <div className="vintage-card">
          <h2 className="text-2xl font-bold text-parchment-dark mb-6 flex items-center gap-2">
            <FileText className="h-6 w-6" />
            Terms of Use
          </h2>
          <p className="text-parchment-dark/80 leading-relaxed mb-6">
            By using our platform, you agree to our guidelines ensuring a respectful and secure learning environment.
          </p>
          <a href="/termsofpolicy" className="inline-flex items-center gap-2 text-parchment-dark hover:text-parchment-dark/80 transition-colors">
            Read Full Terms
            <ExternalLink className="h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Policy;
